import isAppOnline from "../../providers/applicationOnlineStatusProvider";

export default ({ retryCallback } = {}) =>
  () => {
    if (!isAppOnline()) {
      return false;
    }

    retryCallback();

    return true;
  };
